import { useSeo } from "../lib/seo";
import { Hero } from "../components/Hero";
import { Benefits } from "../components/Benefits";
import { WhyUs } from "../components/Sections";
import { HomeDisclaimer } from "../components/Trust";
import { ProgramsTeaser, ExplorePages } from "../components/HomeTeasers";
import { CtaBand } from "../components/SiteFooter";

export default function Home() {
  useSeo({ title: "Online Degrees for Working Professionals | Mirai Educations", description: "Independent counselling for online and distance degrees in India. Free one-to-one guidance for working professionals and graduates. Verify before you apply.", path: "/" });
  return (
    <main data-testid="home-page">
      <Hero />
      <Benefits />
      <ProgramsTeaser />
      <WhyUs />
      <ExplorePages />
      <HomeDisclaimer />
      <CtaBand />
    </main>
  );
}
